import { useEffect, useState } from 'react';
// import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Box, Button, Typography } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';

const FilePreview = ({
  src,
  height = 'auto',
  alt = 'Document',
  maxHeight = '100vh',
  icon = false,
}) => {
  const [type, setType] = useState('unknown');

  useEffect(() => {
    if (!src) return;
    const ext = src.split('.').pop().toLowerCase();
    if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)) setType('image');
    else if (ext === 'pdf') setType('pdf');
    else setType('other');
  }, [src]);

  const openInNew = () => window.open(src, '_blank', 'noopener,noreferrer');

  if (type === 'image')
    return (
      <CardMedia
        component="img"
        src={src}
        alt={alt}
        height={height}
        sx={{ objectFit: 'contain', p: 1, maxHeight }}
      />
    );

  if (type === 'pdf') {
    return icon ? (
      <PictureAsPdfIcon color="error" />
    ) : (
      <Box sx={{ p: 1, height: maxHeight }}>
        {maxHeight === '100vh' && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <PictureAsPdfIcon />
            <Typography>{src?.split('/').pop()}</Typography>
            <Box flex={1} />
            <Button onClick={openInNew} size="small" startIcon={<OpenInNewIcon />}>
              Open
            </Button>
          </Box>
        )}

        <iframe
          style={{ width: '100%', height: '100%', border: 0 }}
          title={alt}
          src={`${src}#zoom=${maxHeight === '100vh' ? 50 : 10}`}
        />
      </Box>
    );
  }

  // fallback for other file types
  return (
    <Box sx={{ p: 2 }}>
      <InsertDriveFileIcon />
      <Typography>{src.split('/').pop()}</Typography>
      <Button onClick={openInNew} size="small" startIcon={<OpenInNewIcon />}>
        Open
      </Button>
    </Box>
  );
};

export default FilePreview;
